import { useEffect } from "react";
import Animated, {
	useSharedValue,
	useAnimatedStyle,
	withTiming,
} from "react-native-reanimated";

type FadeViewProps = {
	children: React.ReactNode;
	/**
	 * The duration of the fade animation in milliseconds.
	 * @default 300
	 */
	duration?: number;
};

export const FadeView = ({ children, duration = 300 }: FadeViewProps) => {
	const opacity = useSharedValue(0);

	useEffect(() => {
		opacity.value = withTiming(1, { duration });
	}, [duration, opacity]);

	const animatedStyle = useAnimatedStyle(() => ({
		opacity: opacity.value,
		maxWidth: "100%",
	}));

	return <Animated.View style={animatedStyle}>{children}</Animated.View>;
};
